import React from 'react'
import { Route, Switch } from 'react-router-dom'
import asyncComponent from './components/AsyncComponent'
import AuthenticatedRoute from './components/AuthenticatedRoute'
import UnauthenticatedRoute from './components/UnauthenticatedRoute'

const AsyncLogin = asyncComponent(() => import ('./containers/Login'))
const AsyncSSO = asyncComponent(() => import('./containers/SSO'))

const AsyncQueue = asyncComponent(() => import ('./containers/Queue'))
const AsyncDashboard = asyncComponent(() => import ('./containers/Dashboard'))
const AsyncNotFound = asyncComponent(() => import ('./containers/NotFound'))
const AsyncTeams = asyncComponent(() => import ('./containers/Teams'))
const AsyncSearch = asyncComponent(() => import('./containers/Search'))
const AsyncTeam = asyncComponent(() => import('./containers/Team'))
const AsyncAdmission = asyncComponent(() => import('./containers/Admission'))
const AsyncChart = asyncComponent(() => import('./containers/Chart'))
const AsyncDenialForm = asyncComponent(() => import('./containers/DenialForm'))
const AsyncReviewForm = asyncComponent(() => import('./containers/ReviewForm'))
const AsyncTrackingLog = asyncComponent(() => import('./containers/Log'))
const AsyncExecutive = asyncComponent(() => import('./containers/Executive'))
const AsyncProductivity = asyncComponent(() => import('./containers/Productivity'))
const AsyncUserDashboard = asyncComponent(() => import('./containers/UserDashboard'))

export default () =>
  <Switch>
    <AuthenticatedRoute path='/' exact component={AsyncDashboard} />

		<UnauthenticatedRoute path='/login' exact component={AsyncLogin} />
		<UnauthenticatedRoute path='/sso' exact component={AsyncSSO} />
    <AuthenticatedRoute path='/queue/:queueid' exact component={AsyncQueue}  />
    <AuthenticatedRoute path='/dashboard' exact component={AsyncDashboard} />
		<AuthenticatedRoute path='/log' exact	component={AsyncTrackingLog} />
    <AuthenticatedRoute path='/executive' exact	component={AsyncExecutive} />
    <AuthenticatedRoute path='/productivity' exact component={AsyncProductivity} />
    <AuthenticatedRoute path='/user-dashboard' exact component={AsyncUserDashboard} />
		<AuthenticatedRoute path='/teams' exact component={AsyncTeams} />
		<AuthenticatedRoute path='/team/:teamid' exact component={AsyncTeam} />
		<AuthenticatedRoute path='/search' exact component={AsyncSearch} />
		<AuthenticatedRoute path='/entity/:entityid/admission/:admissionid' exact	component={AsyncAdmission} />


		<AuthenticatedRoute path='/entity/:entityid/admission/:admissionid/chart' exact	component={AsyncChart} />

		<AuthenticatedRoute path='/entity/:entityid/admission/:admissionid/denial/:id' exact
			component={AsyncDenialForm} />

		<AuthenticatedRoute path='/entity/:entityid/patient/:patientid/admission/:admissionid/review/:id' exact
			component={AsyncReviewForm} />

    { /* Finally, catch all unmatched routes */ }
    <Route component={AsyncNotFound} />
  </Switch>
